const SAVE_SEARCH_PARAMS = 'saveSearchParams';
const CLEAR_SEARCH_PARAMS = 'clearSearchParams';

const actions = {
    saveSearchParams: (params) => ({
        type: SAVE_SEARCH_PARAMS,
        params,
    }),
    clearSearchParams: () => ({
        type: CLEAR_SEARCH_PARAMS,
    })
};

const initialState = {
    searchParams: {},
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_SEARCH_PARAMS:
            return {
                ...state,
                searchParams: action.params,
            };
        case CLEAR_SEARCH_PARAMS:
            return {
                ...state,
                searchParams: {},
            };
        default:
            return state;
    }
};

export { reducer as default, actions };


// WEBPACK FOOTER //
// ./src/actions/researchCenter/detail.js